import styled from "styled-components";

const EditSection = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
`

export default EditSection